export function getImage(name: string): string {
  return '/images/' + name;
}

export function getProjectImage(name: string): string {
  return '/images/project/' + name;
}